import React, { useEffect, useState } from "react";
import ItemStatusList from "./item-status-list/item-status-list";
import ItemStatusAdd from "./item-status-add/item-status-add";
import ItemStatusEdit from "./item-status-edit/item-status-edit";
import ItemStatusDelete from "./item-status-delete/item-status-delete";
import { useNavigate } from "react-router-dom";
import { checkAuthState } from "../../authentication/auth-utils/auth-utils";

const ItemStatusContainer = () => {
    const navigate = useNavigate();
    const [isAuthorized, setIsAuthorized] = useState(null);

    useEffect(() => {
        checkAuthState((isLoggedIn) => {
          setIsAuthorized(isLoggedIn);
        });
    }, []);

    useEffect(() => {
        if (isAuthorized === false) {
          navigate('/');
        }
    }, [isAuthorized, navigate]);

    return (
        <>
            <div style={{ padding: 20 }}>
                <ItemStatusList/>
                <ItemStatusAdd/>
                <ItemStatusEdit/>
                <ItemStatusDelete/>
            </div>
        </>
    )
};

export default ItemStatusContainer;